export enum GridLevelName {
  BILL = 'bill',
  SUBMISSION = 'submission',
  CLIENT_INSURER = 'client insurer',
}

export type AutocompleteSelectOption = {
  value: string;
  label: string;
};

export enum ActionTypeDisplayText {
  ARCHIVE = 'Archive',
  RELEASE = 'Release',
  VOID = 'Void',
  CHECK_ELIGIBILITY = 'Check Eligibility for',
  UPDATE_NETSUITE_ID = 'Update Netsuite ID for',
  CREATE_MANUAL_HOLD = 'Create Manual Hold for',
  PROCESS_COPAYMENT = 'Process Copayment for',
  UPDATE_BILLING_TYPE = 'Update Billing Type for',
}
